class AvtCatalogNavigation extends HTMLElement {
  connectedCallback() {
    const current = new URL(window.location.href);
    const parameter = 'filter.p.m.fitment.discovery_compatibility';
    const values = current.searchParams.getAll(parameter);
    if (!values.length) return;

    this.querySelectorAll('[data-avt-catalog-navigation-link]').forEach((link) => {
      const target = new URL(link.href, window.location.origin);
      if (target.origin !== window.location.origin) return;
      target.searchParams.delete('filter.p.m.fitment.compatibility');
      target.searchParams.delete(parameter);
      values.forEach((value) => target.searchParams.append(parameter, value));
      link.href = target.href;
    });
  }
}

class AvtCatalogGaragePrompt extends HTMLElement {
  connectedCallback() {
    if (this.connected) return;
    this.connected = true;
    document.addEventListener('avt:garage-change', this.handleGarageChange);
    window.addEventListener('storage', this.handleStorage);
    window.addEventListener('pageshow', this.handlePageShow);
    this.render(this.readGarage());
  }

  disconnectedCallback() {
    this.connected = false;
    document.removeEventListener('avt:garage-change', this.handleGarageChange);
    window.removeEventListener('storage', this.handleStorage);
    window.removeEventListener('pageshow', this.handlePageShow);
  }

  readGarage() {
    if (typeof window.AVTGarage?.read === 'function') {
      return window.AVTGarage.read();
    }
    try {
      return JSON.parse(window.localStorage.getItem(this.dataset.garageStorageKey)) || {};
    } catch {
      return {};
    }
  }

  render(garage = {}) {
    this.hidden = Array.isArray(garage?.bikes) && garage.bikes.length > 0;
  }

  handleGarageChange = (event) => {
    this.render(event.detail?.garage || this.readGarage());
  };

  handleStorage = (event) => {
    if (
      event.key === this.dataset.garageStorageKey
      || event.key === (window.AVTGarage?.garageStorageKey || 'avt-garage-v1')
    ) {
      this.render(this.readGarage());
    }
  };

  handlePageShow = () => {
    this.render(this.readGarage());
  };
}

if (!customElements.get('avt-catalog-navigation')) {
  customElements.define('avt-catalog-navigation', AvtCatalogNavigation);
}

if (!customElements.get('avt-catalog-garage-prompt')) {
  customElements.define('avt-catalog-garage-prompt', AvtCatalogGaragePrompt);
}
